import { splitProps } from "solid-js";
import { cn } from "./../libs/cn";
import { Card, CardContent } from "@/components/shadcn/card";

export default function AuthLayout(props) {

  const [local, others] = splitProps(props, ["class", "children"])

  return (
    <div class="bg-white dark:bg-black">
      <div class="sm:hidden p-3">
        {props.children}
      </div>
      <div class="container relative hidden h-[100vh] flex-col items-center justify-center sm:grid lg:max-w-none lg:grid-cols-2 lg:px-0">
        <div class="relative hidden h-full flex-col bg-muted p-10 text-white dark:border-r lg:flex">
          <div class="absolute inset-0 bg-zinc-900" />
          <div class="relative z-20 flex items-center text-lg font-medium">
            <img src="/assets/images/logo.png" class="w-[96px]" />
            (THERAPY)
          </div>
          <div class="relative z-20 mt-auto">
            <blockquote class="space-y-2">
              <p class="text-xs">Developed By</p>
              <footer class="text-lg">Blackends</footer>
            </blockquote>
          </div>
        </div>
        <div class="lg:p-8">
          <div class="mx-auto flex w-full flex-col justify-center space-y-6 sm:w-[350px]">
            {props.children}
          </div>
        </div>
      </div>
    </div>
  );
}
